document.addEventListener('click', function (e) {
  var link = e.target.closest('a[href^="#common-tabbar-container-"]');
  if (!link) return;

  var id = link.getAttribute('href').slice(1); // common-tabbar-container-overview3
  var tab = document.querySelector('.common-tabbar-item[data-id="' + id + '"]');
  if (!tab) return; // 没有对应 tab 时保留默认行为

  e.preventDefault();
  tab.click(); // 复用 tabbar 的整套逻辑
});
function initAutumnAccessories() {
  var el = document.querySelector('.main-content > .autumn-sale-2026-formal')
  if (el) {
    el.classList.add('autumn-sale-2026')
  }
  // 配件区（autumn-sale-2026-accessories）的轮播与优惠码复制逻辑已内联在 section 中
}

function initAutumnSaleTabCtas() {
  document.querySelectorAll('.autumn-sale-2026-floor-care').forEach(function (section) {
    if (section.dataset.ctasBound === 'true') return
    section.dataset.ctasBound = 'true'
    section.addEventListener('click', function (event) {
      var tab = event.target.closest('.p-sale-swiper-group-name')
      if (!tab || !section.contains(tab)) return
      var index = Number(tab.dataset.index)
      var links = section.querySelectorAll('.autumn-sale-2026-floor-care-cta')
      links.forEach(function (link, linkIndex) {
        link.classList.toggle('is-active', linkIndex === index)
      })
    })
  })
}

function initAutumnSaleAnchorLinks() {
  if (document.documentElement.dataset.autumnAnchorLinksBound === 'true') return
  document.documentElement.dataset.autumnAnchorLinksBound = 'true'

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.autumn-sale-2026-official-card-cta[href*="#"], a.autumn-sale-2026-anchor-link[href*="#"]')
    if (!link) return

    var href = link.getAttribute('href') || ''
    var hashIndex = href.indexOf('#')
    if (hashIndex < 0 || hashIndex === href.length - 1) return

    var targetId
    try {
      targetId = decodeURIComponent(href.slice(hashIndex + 1))
    } catch (error) {
      return
    }
    var tab = Array.prototype.find.call(document.querySelectorAll('.common-tabbar-item[data-id]'), function (item) {
      return item.getAttribute('data-id') === targetId
    })
    if (!tab) return

    event.preventDefault()
    tab.click()
  })
}

// p_sale_swiper_M8kR2q（Best Sellers 会员区）：用 general-methods.js 的 autoHeight 统一产品卡的
// 描述（p-sale-product-card-product-description）与价格框（p-sale-product-card-product-price-box）高度
function initAutumnMembersCardHeight() {
  if (typeof window.$ !== 'function' || typeof window.autoHeight !== 'function') return

  var sectionSelector = '.autumn-sale-2026-members'
  var descriptionSelector = sectionSelector + ' .p-sale-product-card-product-description'
  var priceBoxSelector = sectionSelector + ' .p-sale-product-card-product-price-box'
  var swiperSelector = sectionSelector + ' p-sale-swiper'
  var timer

  function isMeasurable(selector) {
    var element = document.querySelector(selector)
    return !!(element && element.getClientRects().length > 0)
  }

  function equalizeHeights() {
    // 区域不可见（如被隐藏）时不计算，避免取到 0 高度
    if (!isMeasurable(descriptionSelector) || !isMeasurable(priceBoxSelector)) return

    // 先重置，确保每次都以内容自然高度参与比较
    $(descriptionSelector).css('height', 'auto')
    $(priceBoxSelector).css('height', 'auto')
    window.autoHeight(descriptionSelector, false)
    window.autoHeight(priceBoxSelector, false)

    // 卡片高度变化后同步 swiper 尺寸
    document.querySelectorAll(swiperSelector).forEach(function (swiperElement) {
      if (typeof swiperElement.updateSwiper === 'function') swiperElement.updateSwiper()
      var groupSwiper = swiperElement.groupSwiperInstance
      if (groupSwiper && typeof groupSwiper.updateAutoHeight === 'function') groupSwiper.updateAutoHeight(0)
    })
  }

  function scheduleEqualize(delay) {
    window.clearTimeout(timer)
    timer = window.setTimeout(function () {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(equalizeHeights)
      })
    }, delay || 0)
  }

  scheduleEqualize()

  // 等待区域内 swiper 初始化完成后再计算一次，保证分组布局已稳定
  var swiperElement = document.querySelector(swiperSelector)
  var attempts = 0
  function waitForSwiper() {
    if (!swiperElement || (swiperElement.childSwiperInstances && swiperElement.childSwiperInstances.length)) {
      scheduleEqualize()
      return
    }
    attempts += 1
    if (attempts <= 120) window.requestAnimationFrame(waitForSwiper)
  }
  waitForSwiper()

  window.addEventListener('resize', function () {
    scheduleEqualize(260)
  })

  window.addEventListener('load', function () {
    scheduleEqualize()
  })

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      scheduleEqualize()
    })
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAutumnAccessories)
  document.addEventListener('DOMContentLoaded', initAutumnSaleTabCtas)
  document.addEventListener('DOMContentLoaded', initAutumnSaleAnchorLinks)
  // document.addEventListener('DOMContentLoaded', initAutumnMembersCardHeight)
} else {
  initAutumnAccessories()
  initAutumnSaleTabCtas()
  initAutumnSaleAnchorLinks()
  // initAutumnMembersCardHeight()
}
